import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as AppConsts from '@/utilities/AppConsts';

export interface MapFiltersState {
  men: boolean,
  women: boolean,
  ageMin: number,
  ageMax: number,
  heightMin: number,
  heightMax: number,
}

const initialState: MapFiltersState = {
  men: true,
  women: true,
  ageMin: AppConsts.MIN_AGE,
  ageMax: AppConsts.MAX_AGE,
  heightMin: AppConsts.MIN_HEIGHT_INCHES,
  heightMax: AppConsts.MAX_HEIGHT_INCHES,
} satisfies MapFiltersState as MapFiltersState;

export const mapFiltersSlice = createSlice({
  name: 'mapfilters',
  initialState,
  reducers: {
    updateMapFilters: (state, newState: PayloadAction<MapFiltersState>) => {
      state.men = newState.payload.men;
      state.women = newState.payload.women;
      state.ageMin = newState.payload.ageMin;
      state.ageMax = newState.payload.ageMax;
      state.heightMin = newState.payload.heightMin;
      state.heightMax = newState.payload.heightMax;
    },
    updateMen: (state, newState: PayloadAction<boolean>) => {
      state.men = newState.payload;
    },
    updateWomen: (state, newState: PayloadAction<boolean>) => {
      state.women = newState.payload;
    },
  },
});

export const {
  updateMapFilters,
  updateMen,
  updateWomen,
} = mapFiltersSlice.actions;

export default mapFiltersSlice.reducer;
